import React, { useState, useContext } from 'react';
import { Container, Box,CircularProgress,   Typography,Stack, TextField, Select, MenuItem, InputLabel, FormControl, Button, Alert } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ticketApi from '../../api/ticketApi';
import { AuthContext } from '../../auth/AuthContext';
import BackButtonDesktop from '../../components/BackButtonDesktop';

export default function TicketCreatePageDesktop() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [form, setForm] = useState({ oggetto:'', categoria:'', priorita:'', messaggio:'' });
  const [err, setErr] = useState(null);
  const CATEGORIE = ['ASSISTENZA','BUG','RICHIESTA_INTERNA','AMMINISTRATIVO'];
  const PRIORITA = ['BASSA','MEDIA','ALTA'];


  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
        setLoading(true);
      console.log("form",form);
        const formData = new FormData();

        formData.append(
          "data",
          new Blob([JSON.stringify(form)], { type: "application/json" })
        );

        selectedFiles.forEach(file => {
          formData.append("files", file);
        });
      await ticketApi.create(formData);
      setLoading(false);
      navigate('/tickets');
    } catch (e) {
      setErr(e.response?.data?.error || e.message || 'Errore creazione ticket');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
        {loading && <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1300 }}><CircularProgress size={48}/></Box>}
      {err && <Alert severity="error">{err}</Alert>}
      <Stack spacing={2} sx={{ mt: 2 }}>
        <TextField label="Oggetto" name="oggetto" value={form.oggetto} onChange={handleChange} fullWidth />
        <FormControl fullWidth>
          <InputLabel>Categoria</InputLabel>
          <Select name="categoria" value={form.categoria} onChange={handleChange} label="Categoria">
            {CATEGORIE.map(c => <MenuItem key={c} value={c}>{c}</MenuItem>)}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel>Priorità</InputLabel>
          <Select name="priorita" value={form.priorita} onChange={handleChange} label="Priorità">
            {PRIORITA.map(p => <MenuItem key={p} value={p}>{p}</MenuItem>)}
          </Select>
        </FormControl>
        <TextField
          label="Messaggio iniziale"
          name="messaggio"
          value={form.messaggio}
          onChange={handleChange}
          multiline
          rows={4}
          fullWidth
        />
              {/* UPLOAD FILE MULTIPLI */}
              <Stack direction="row" spacing={1}>
                <input
                  type="file"
                  multiple
                  style={{ display: 'none' }}
                  id="ticketmessage-file-upload"
                  onChange={(e) => {
                    const newFiles = Array.from(e.target.files);
                    setSelectedFiles(prev => [...prev, ...newFiles]); // Accoda i file
                  }}
                />
                <label htmlFor="ticketmessage-file-upload">
                  <Button variant="outlined" component="span">
                    {selectedFiles.length > 0
                      ? `${selectedFiles.length} file selezionati`
                      : 'Sfoglia file'}
                  </Button>
                </label>
                {selectedFiles.length > 0 && (
                  <Stack spacing={0.5} sx={{ ml: 1 }}>
                    {selectedFiles.map((file, index) => (
                        <Stack key={index} direction="row" alignItems="center" spacing={0.5}>
                          <Typography variant="caption">{file.name}</Typography>
                          <Button
                            size="small"
                            color="error"
                            onClick={() => {
                              setSelectedFiles(prev => prev.filter((_, i) => i !== index));
                            }}
                          >
                            ✕
                          </Button>
                        </Stack>
                    ))}
                  </Stack>
                )}
              </Stack>
        <Button variant="contained" onClick={handleSubmit}>Crea Ticket</Button>
      </Stack>
    </Container>
  );
}